import React, { useState } from 'react';
import CompanyInformationComponentProps from './CompanyInformation.types';
import styles from './CompanyInformation.module.scss';
import DateTime from '../../atoms/DateTime';
import Button from '../../atoms/Button';
import DateInput from '../DateInput';
import Heading from '../../atoms/Heading';

const dateTimeSetup = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
};

const ErrorText = ({ children, ...rest }) => (
  <div className={styles.errorText} data-cy='ErrorText' {...rest}>
    {children}
  </div>
);

const CompanyInformation = ({
  isEdit,
  tradingName,
  registrationNumber,
  registeredAddress,
  businessStartDate,
  businessStartDateErrorMessage = 'Business start date is required',
  onDateChange,
  onIncorrectClick,
  incorrectTrackingLabel,
  labels = {
    incorrect: 'Incorrect?',
    registrationNumber: 'Registration number',
    registeredAddress: 'Registered address',
    companyStartDate: 'Company start date',
  },
}: CompanyInformationComponentProps) => {
  const [startDateError, setStartDateError] = useState<string>(null);

  const handleDateChange = (event) => {
    const date = event.currentTarget.value;

    onDateChange(date);
    setStartDateError(date !== null ? null : businessStartDateErrorMessage);
  };

  const DateComponent = isEdit ? (
    <>
      <div className={styles.dateEditContainer}>
        <DateInput value={businessStartDate} onChange={handleDateChange} />
        <ErrorText>{startDateError}</ErrorText>
      </div>
    </>
  ) : (
    <>
      <DateTime ISODateTime={businessStartDate} options={dateTimeSetup} />
      <Button
        variant='link'
        className={styles.actionButton}
        trackingLabel={incorrectTrackingLabel}
        onClick={onIncorrectClick}>
        {labels.incorrect}
      </Button>
    </>
  );

  const editClassName = `
    ${styles.companyInformationContainer} 
    ${styles.editedbackground} ${!isEdit && styles.background}
    `;

  const hasRegisteredAddressOrCity: boolean = !!(registeredAddress?.city || registeredAddress?.country);
  const hasRegisteredAddressAndCity: boolean = !!(registeredAddress?.city && registeredAddress?.country);

  const hasLine2: boolean = !!registeredAddress?.line2;

  return (
    <div className={editClassName}>
      <Heading bold heading='h2' styleAs='h3'>
        {labels.registrationNumber}
      </Heading>
      <p>{registrationNumber}</p>
      <br />
      <Heading bold heading='h2' styleAs='h3'>
        {labels.registeredAddress}
      </Heading>
      <p>{registeredAddress?.postCode}</p>
      <p>{tradingName}</p>
      <p>{registeredAddress?.line1}</p>
      {hasLine2 && <p>{registeredAddress?.line2}</p>}
      {hasRegisteredAddressOrCity && (
        <p>
          {`${registeredAddress?.city ?? ''}${hasRegisteredAddressAndCity ? ', ' : ''}${
            registeredAddress?.country ?? ''
          }`}
        </p>
      )}
      <br />
      <Heading bold heading='h2' styleAs='h3'>
        {labels.companyStartDate}
      </Heading>
      <div className={!isEdit ? styles.date : styles.dateLayout}>{DateComponent}</div>
    </div>
  );
};

export default CompanyInformation;
